import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { HelperService } from "../../services/helper.service";
import { MapDesignationService } from "../../services/mapdesignation.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { IOption } from "ng-select";

import { AssessmentService } from "../../services/assessment.service";
import { ObjectivesService } from "../../services/objectives.service";
import { RilrService } from "../../services/rilr.service";

@Component({
  selector: "app-create-new-objectives-designation-edit",
  templateUrl: "./create-new-objectives-designation-edit.component.html",
  providers: [ObjectivesService, RilrService],
})
export class EditCreateDesigModalComponent implements OnInit {
  @Input() auto_id: number;
  validateForm: FormGroup;
  DesList: any = {
    desigid: "",
    designation: "",
  };

  @Output() dataToEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("swalModalUpdateMapDesig") swalModalUpdateMapDesig: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  companySystemID = +this.helperService.getSelectedCompanyId();

  public employeeOption: Array<IOption> = [];
  public isEdit: number;
  public formData: any = {};

  constructor(
    private formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private objectivesService: ObjectivesService,
    private assessmentService: AssessmentService,
    private rilrService: RilrService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.auto_id = Number(
      localStorage.getItem("objective-designation-edit-auto_id")
    );
    localStorage.removeItem("objective-designation-edit-auto_id");
    console.log(this.auto_id);
  }

  public typehead(value: any): void {
    if (value.length > 2) {
      this.getEmployees(value);
    } else {
      this.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          if (that.isEdit == 1) {
            setTimeout(() => {
              that.formData.assessor_id = that.helperService.setSelectedValue(
                that.formData.assessor_id
              );
            }, 0);
          }
        },
        (err) => {
          console.log(err);
          that.employeeOption = [];
        }
      );
  }

  updateMapAssessor(formData: any) {
    console.log(this.auto_id);
    const requestData = {
      auto_id: this.auto_id,
      assessor_id: formData.assessor_id,
    };
    console.log(requestData);
    let that = this;
    this.objectivesService
      .updateMapAssessor(this.auto_id)
      .customPUT(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.successMsg = "Successfully updated map designation";
          this.swalModalUpdateMapDesig.show();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/create-new-objectives-designation-edit/create-new-objectives-designation-edit.component.ts